import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://api.magnirauniverse.com";

const money = (value) => `₹${Number(value || 0).toFixed(2)}`;

const VendorRateForm = () => {
  const { token } = useParams();

  const [estimate, setEstimate] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitted, setSubmitted] = useState(false);

  const totalAmount = useMemo(
    () => items.reduce((sum, item) => sum + Number(item.vendorAmount || 0), 0),
    [items],
  );

  const fetchForm = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/vendor-rate-form/${token}`);

      setEstimate(res.data);
      setItems(res.data.items || []);

      if (res.data.status === "SUBMITTED") {
        setSubmitted(true);
      }
    } catch (err) {
      console.error("Vendor form fetch error:", err?.response?.data || err);
      alert(err?.response?.data?.message || "Invalid or expired form link.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchForm();
  }, [token]);

  const updateItem = (index, field, value) => {
    const updated = [...items];

    updated[index][field] = value;

    if (field === "vendorRate") {
      updated[index].vendorAmount =
        Number(value || 0) * Number(updated[index].qty || 0);
    }

    setItems(updated);
  };

  const submitRates = async () => {
    try {
      const hasEmptyRate = items.some((i) => !i.vendorRate);

      if (hasEmptyRate) {
        alert("Please enter rate for all items.");
        return;
      }

      await axios.post(`${BASE_URL}/api/vendor-rate-form/${token}/submit`, {
        items,
        totalAmount,
      });

      setSubmitted(true);
      alert("Rates submitted successfully.");
    } catch (err) {
      console.error("Submit rates error:", err?.response?.data || err);
      alert(err?.response?.data?.message || "Failed to submit rates.");
    }
  };

  if (loading) return <div style={{ padding: 30 }}>Loading...</div>;

  if (!estimate) return <div style={{ padding: 30 }}>Form not found.</div>;

  return (
    <div style={{ padding: 30, background: "#f5f7fa", minHeight: "100vh" }}>
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          background: "#fff",
          padding: 25,
          borderRadius: 12,
          boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
        }}
      >
        <h2>Vendor Rate Submission Form</h2>

        <div className="mb-3">
          <b>Project:</b> {estimate.projectName}
          <br />
          <b>Vendor:</b> {estimate.vendorName}
          <br />
          <b>Vendor Code:</b> {estimate.vendorCode || "-"}
        </div>

        {submitted && (
          <div className="alert alert-success fw-bold">
            This form has already been submitted.
          </div>
        )}

        <div style={{ overflowX: "auto" }}>
          <table className="table table-bordered table-striped">
            <thead className="table-secondary text-center">
              <tr>
                <th>Sr No</th>
                <th>Item</th>
                <th>Description</th>
                <th>Qty</th>
                <th>Area</th>
                <th>Your Rate</th>
                <th>Amount</th>
                <th>Remark</th>
              </tr>
            </thead>

            <tbody>
              {items.map((row, index) => (
                <tr key={index}>
                  <td className="text-center">{index + 1}</td>
                  <td>{row.itemName || "-"}</td>
                  <td>{row.description || "-"}</td>
                  <td className="text-center">{row.qty || 0}</td>
                  <td>{row.area || "-"}</td>

                  <td>
                    <input
                      type="number"
                      className="form-control"
                      value={row.vendorRate || ""}
                      disabled={submitted}
                      onChange={(e) =>
                        updateItem(index, "vendorRate", e.target.value)
                      }
                    />
                  </td>

                  <td>
                    <input
                      className="form-control fw-bold"
                      value={row.vendorAmount ? money(row.vendorAmount) : ""}
                      readOnly
                    />
                  </td>

                  <td>
                    <input
                      className="form-control"
                      value={row.vendorRemark || ""}
                      disabled={submitted}
                      onChange={(e) =>
                        updateItem(index, "vendorRemark", e.target.value)
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>

            <tfoot>
              <tr style={{ background: "#dcfce7" }}>
                <td colSpan="6" className="text-end fw-bold">
                  Total Amount
                </td>
                <td className="text-end fw-bold">{money(totalAmount)}</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div
          style={{
            marginTop: 15,
            padding: "14px 18px",
            borderRadius: 10,
            background: "#ecfdf5",
            border: "1px solid #86efac",
            display: "flex",
            justifyContent: "space-between",
            fontSize: 18,
            fontWeight: 900,
          }}
        >
          <span>Grand Total</span>
          <span>{money(totalAmount)}</span>
        </div>

        {!submitted && (
          <div className="text-end mt-3">
            <button className="btn btn-primary" onClick={submitRates}>
              Submit Rates
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default VendorRateForm;
